var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Icon, AvailableIcons } from '../../components/Icon/Icon.element';
import { P } from '../../components/UI-helpers/typography';
import { Button } from '../../components/Button/button.element';
import Input from '../../components/Input/input.element';
import ButtonLink from '../../components/ButtonLink';
var AccountDelete = /** @class */ (function (_super) {
    __extends(AccountDelete, _super);
    function AccountDelete() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccountDelete.prototype.render = function () {
        var _this = this;
        return (_jsxs("div", __assign({ className: "flex flex-1 flex-col p-16" }, { children: [_jsx("div", __assign({ className: "flex flex-row justify-between" }, { children: _jsx("div", __assign({ className: "flex flex-1 flex-row items-center justify-start" }, { children: _jsx(ButtonLink, __assign({ onClick: function () { return _this.props.navigate(-1); } }, { children: _jsxs("div", __assign({ className: "flex flex-row items-center" }, { children: [_jsx(Icon, { name: AvailableIcons.ChevronLeft, size: "large" }), _jsx(P, __assign({ black: true, bold: true, fontSize: 24 }, { children: "Back" }))] })) })) })) })), _jsx("div", __assign({ className: "flex flex-row justify-center" }, { children: _jsx(P, __assign({ black: true, bold: true, fontSize: 24 }, { children: "Appspotr Account Deletion Confirmation" })) })), _jsx("div", __assign({ className: "flex flex-1 flex-row justify-center" }, { children: _jsxs("div", __assign({ className: "flex flex-1 flex-col justify-center items-center" }, { children: [_jsx(P, __assign({ black: true }, { children: "To delete your Appspotr account please, confirm your password below and" })), _jsx(P, __assign({ black: true }, { children: "Type DELETE. Your data will be permanantly deleted." }))] })) })), _jsx("div", __assign({ className: "flex flex-1 flex-row justify-center" }, { children: _jsxs("div", __assign({ className: "w-1/5" }, { children: [_jsx(Input, { label: "Password" }), _jsx("div", { className: "pt-4" }), _jsx(Input, { label: "Type DELETE" })] })) })), _jsx("div", __assign({ className: "flex flex-1 flex-row justify-center" }, { children: _jsx(Button, __assign({ width: 200, type: "danger" }, { children: "Confirm" })) }))] })));
    };
    return AccountDelete;
}(React.Component));
var AccountDeletePageWrapper = function (props) {
    var params = useParams();
    var navigate = useNavigate();
    return _jsx(AccountDelete, __assign({ params: params, navigate: navigate }, props));
};
export default AccountDeletePageWrapper;
